import { SxStyles } from '../../../types';
import theme from '../../../theme';
import { getResponsiveSize, laptopRatio } from '../../../utils';
import { fingerBtnHeght } from './PhaserActionButton';

const initialFingerBtnHeight = '30%';
const fingerOffset = getResponsiveSize(fingerBtnHeght - 145);
export const PhaserActionButtonStyle: SxStyles = {
  buttonContainer: {
    position: 'absolute',
    width: '100%w',
    height: '100%',
    zIndex: 2,
    '& .finger-button': {
      position: 'fixed',
      opacity: 0.4,
    },
    '&.left': {
      pr: getResponsiveSize(20),
    },
    '&.right': {
      pl: getResponsiveSize(20),
    },
    '& .visual, & .calculation': {
      bottom: `calc(${initialFingerBtnHeight} - ${fingerOffset} + ${getResponsiveSize(10)})`,
    },
    '& .visual': { left: getResponsiveSize(-114) },
    '& .calculation': { right: getResponsiveSize(-114) },

    '& .audio, & .stroop': {
      bottom: `calc(${initialFingerBtnHeight} - ${fingerOffset} - ${getResponsiveSize(110)})`,
    },
    '& .audio': {
      left: getResponsiveSize(-140),
    },
    '& .stroop': {
      right: getResponsiveSize(-140),
    },
    '& .animation': {
      right: getResponsiveSize(-145),
      bottom: `calc(${initialFingerBtnHeight} - ${fingerOffset} - ${getResponsiveSize(249)})`,
    },
    '& .calculation, & .stroop, & .animation, & .visual, & .audio': {
      '& .MuiSvgIcon-root': {
        fontSize: getResponsiveSize(58),
      },
    },
    '& .active-finger': {
      opacity: 0.7,
    },
  },
};
